import React, { useEffect, useState } from 'react';
import { ImagePreLoading } from '@Components/';
import { Box, Typography } from '@curves/ui-base';
import { useMeasurementContext } from '@Local/Measurement/Context/MeasurementContext';
import useMemberInbodyApi from "@Apis/useMemberInbodyApi";
import { isEmpty } from '@Util/utils';
import { HtmlFrameComponent } from "@Local/Measurement/Components/Common";


const MeasurementTranscriptPage = () => {
    const { measureID } = useMeasurementContext();
    const { getMemberInbodyTranscriptPageApi } = useMemberInbodyApi();
    const [pageData, setPageData] = useState(null);

    const doTranscriptResultPageApi = async () => {
        const resp = await getMemberInbodyTranscriptPageApi(measureID);
        if (resp) {
            setPageData(resp);
        }
    };

    useEffect(
        () => {
            if (measureID) {
                doTranscriptResultPageApi(measureID);
            }
        },
        // eslint-disable-next-line
        [measureID],
    );

    if (isEmpty(pageData)) return null;

    const { hasData, useImage, transcriptUrl, clubRankingUrl, ageGroupUrl } = pageData;

    return (
        <>
            {!hasData &&
                <Box className={'container page-center'}>
                    <Box className={'measurement-empty px-3 py-2'}>暫無<strong>成績單</strong>內容</Box>
                </Box>}
            {hasData && (
                <>
                    <Box className={'container-full page-center'}>
                        {useImage ? <>
                            <Typography variant={'body2'} className={'px-3 font-color-1'}>
                                ※ 提醒：對圖片長按可儲存到您的裝置
                            </Typography>
                            {clubRankingUrl !== '' && <ImagePreLoading src={clubRankingUrl} alt={'店舖成績單'} loadingText={'成績單產生中'} useSportsEquipment />}
                            <p></p>
                            {ageGroupUrl !== '' && <ImagePreLoading src={ageGroupUrl} alt={'店舖成績單'} loadingText={'成績單產生中'} useSportsEquipment />}
                        </> : <>
                            <HtmlFrameComponent title="成績單" pageUrl={transcriptUrl} floatButtonClass={''} />
                        </>}
                    </Box>
                </>
            )}
        </>


    );
};

export default MeasurementTranscriptPage;
